/** @format */

import { useEffect } from 'react';

export const useToggleZendeskWidget = (hideDropdown: boolean, hideUnderPx?: number) => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (hideUnderPx && window.innerWidth > hideUnderPx) return;
      if (!(window as any).zE) return;
      if (hideDropdown) (window as any).zE('messenger:set', 'zIndex', -1);
      else (window as any).zE('messenger:set', 'zIndex', 999);
    }
  }, [hideDropdown]);
};
